import React from 'react';

import Bracket from './Bracket';
import JsonLogicBuilder from './index';
import Divider from './Divider';
import Delete from './Delete';

const operators = [
  {value: '+', label: '+'},
  {value: '-', label: '-'},
  {value: '*', label: '×'},
  {value: '/', label: '÷'},
  {value: '%', label: 'mod'}
];

function MathExpression({variables, operator, value, onChange, onCollapse, expressionTypes}) {
  return (
    <Bracket onCollapse={onCollapse}>
      <JsonLogicBuilder
        expand
        variables={variables}
        expressionTypes={expressionTypes}
        value={value[0]}
        onChange={nextValue => onChange({[operator]: [nextValue, value[1]]})}
      />
      <Divider />
      <MathOperationSelector
        value={operator}
        onChange={nextOperator => onChange({[nextOperator]: value})}
      />
      <Delete onClick={() => onChange(null)} />
      <Divider />
      <JsonLogicBuilder
        expand
        variables={variables}
        expressionTypes={expressionTypes}
        value={value[1]}
        onChange={nextValue => onChange({[operator]: [value[0], nextValue]})}
      />
    </Bracket>
  );
}

function MathOperationSelector({value, onChange}) {
  return (
    <select value={value} onChange={e => onChange(e.target.value)}>
      {operators.map(operator => (
        <option key={operator.value} value={operator.value}>
          {operator.label}
        </option>
      ))}
    </select>
  );
}

export default MathExpression;
